import {creativesApi} from 'common/src/modules/creatives/creatives.api';
import {CLStore} from 'common/src/redux/store';

export default async function getCreativeById(creativeId: number, store: CLStore) {
  const {creatives} = store.getState().creativesLibrary;

  // First check if creative is already in the library
  const existingCreative = creatives.find((creative) => creative.id === creativeId);

  if (existingCreative) {
    return existingCreative;
  }

  const result = await creativesApi.get({
    id: creativeId,
    includeDynamicParams: true,
  });

  return result.creative;
}
